module.exports = __webpack_public_path__ + "img/blue_049.cf123edb.png";